import { Button, Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledBodyModal = styled(Modal.Body)`
    text-align: center;

    .description {
        font-size: 14px;
        font-family: 'Montserrat', sans-serif;
        color: #707070;
        margin-bottom: 10px;
    }

    .modal-title {
        font-size: 20px;
        font-weight: 600;
        margin: 10px 0;
        font-family: 'Montserrat', sans-serif;
    }

    .modal-body svg {
        height: 100px;
        width: 100px;
        fill: #ef8526;
        opacity: 1;
    }
`;

export const StyledConfirmButton = styled(Button)`
    margin: 5px;
    width: 100px;
`;

export const StyledCancelButton = styled(Button)`
    margin: 5px;
    width: 100px;
    background-color: #ffffff;
    border: 1px solid #f2994a;
    color: #f2994a !important;

    :hover {
        background-color: #fefaf6;
        color: #e67511 !important;
        border-color: #e67511;
    }

    :disabled {
        background-color: #ffffff;
        color: #f6b77f !important;
        border-color: #f6b77f;
    }
`;
